export interface UploadResult {
  fileUrl: string;
  fileName: string;
  key?: string;
  urls?: {
    full: string;
    medium: string;
    small: string;
    xsmall: string;
  };
}

export async function uploadFile(
  file: File,
  folder: string
): Promise<UploadResult> {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("folder", folder);

  // The server decides role and size policy from ?folder= before reading the
  // body; the form field must match it.
  const res = await fetch(`/api/upload?folder=${encodeURIComponent(folder)}`, {
    method: "POST",
    body: formData,
  });

  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || "Failed to upload file");
  }

  const data = await res.json();
  return { ...data, fileName: file.name };
}
